import React, { useState } from 'react';

const EventForm = ({ event, onSave, onCancel }) => {
    const [form, setForm] = useState({
        startDate: event?.startDate || '',
        endDate: event?.endDate || '',
        site: event?.site || '',
        eventType: event?.eventType || '',
        description: event?.description || ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(form);
    };

    return (
        <form className="em-form" onSubmit={handleSubmit}>
            <h2 className="em-form-title">{event ? 'Edit Event' : 'New Event'}</h2>

            <div className="em-form-row">
                <label className="em-form-label">Start Date</label>
                <input
                    type="date"
                    name="startDate"
                    value={form.startDate}
                    onChange={handleChange}
                    className="em-form-input"
                    required
                />
            </div>

            <div className="em-form-row">
                <label className="em-form-label">End Date</label>
                <input
                    type="date"
                    name="endDate"
                    value={form.endDate}
                    onChange={handleChange}
                    className="em-form-input"
                    required
                />
            </div>

            <div className="em-form-row">
                <label className="em-form-label">Site</label>
                <input
                    type="text"
                    name="site"
                    value={form.site}
                    onChange={handleChange}
                    className="em-form-input"
                    required
                    placeholder="Camp Someplace"
                />
            </div>

            <div className="em-form-row">
                <label className="em-form-label">Event Type</label>
                <input
                    type="text"
                    name="eventType"
                    value={form.eventType}
                    onChange={handleChange}
                    className="em-form-input"
                    required
                    placeholder="Normal, Holiday, etc."
                />
            </div>

            <div className="em-form-row">
                <label className="em-form-label">Description</label>
                <textarea
                    name="description"
                    value={form.description}
                    onChange={handleChange}
                    className="em-form-input em-form-textarea"
                    rows={3}
                    placeholder="Optional description"
                />
            </div>

            <div className="em-form-actions">
                <button type="submit" className="em-btn em-btn-primary">
                    {event ? 'Save Changes' : 'Create Event'}
                </button>
                <button type="button" className="em-btn em-btn-secondary" onClick={onCancel}>
                    Cancel
                </button>
            </div>
        </form>
    );
};

export default EventForm;
